import script from "./MultiTab.vue?vue&type=script&lang=js"
export * from "./MultiTab.vue?vue&type=script&lang=js"

import "./MultiTab.vue?vue&type=style&index=0&id=1da69f91&lang=less&scoped=true"

import exportComponent from "/build/cloudstack-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1da69f91"]])

export default __exports__